import { z } from 'zod'
import { useApiMutation } from '../../utils/useApi'

// ============================================
// POST /update_lp_access_config
// ============================================

const UpdateLpAccessConfigRequestSchema = z
    .object({
        device: z.string(),
        lp_access_station_mapping: z.string().max(20).nullable().optional(),
        lp_access_staleness_time_s: z.number().int().positive().nullable().optional(),
        lp_access_deduplication_time_s: z.number().int().positive().nullable().optional()
    })
    .strict()
    .refine((data) => {
        // At least one lp_access field must be provided (excluding device)
        return (
            data.lp_access_station_mapping !== undefined ||
            data.lp_access_staleness_time_s !== undefined ||
            data.lp_access_deduplication_time_s !== undefined
        )
    }, 'At least one lp_access field must be provided')

const UpdateLpAccessConfigResponseSchema = z.object({
    device: z.string(),
    lp_access_station_mapping: z.string().max(20).nullable().optional(),
    lp_access_staleness_time_s: z.number().int().positive().nullable().optional(),
    lp_access_deduplication_time_s: z.number().int().positive().nullable().optional()
})

export type UpdateLpAccessConfigRequest = z.infer<typeof UpdateLpAccessConfigRequestSchema>
export type UpdateLpAccessConfigResponse = z.infer<typeof UpdateLpAccessConfigResponseSchema>

export { UpdateLpAccessConfigRequestSchema, UpdateLpAccessConfigResponseSchema }

export const useUpdateLpAccessConfigMutation = () =>
    useApiMutation<UpdateLpAccessConfigRequest, typeof UpdateLpAccessConfigResponseSchema>(
        '/access-control/update_lp_access_config',
        UpdateLpAccessConfigResponseSchema
    )
